module.exports = __webpack_public_path__ + "static/analog-photo-20-505a1019d4f11bae8cdea47b81a2881f.jpg";